import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { MenuItem } from 'primeng/api';
import { DynamicDialogRef, DialogService } from 'primeng/dynamicdialog';
import Swal from 'sweetalert2';
import { OrganisationstatisticsService } from './organisationstatistics.service';
import { PagehelpmodalService } from '../../directives/pagehelpmodal/pagehelpmodal.service';

@Component({
  selector: 'app-organisationstatistics',
  templateUrl: './organisationstatistics.component.html',
  styleUrls: ['./organisationstatistics.component.css'],
  providers: [DatePipe]

})
export class OrganisationstatisticsComponent {

  ref: DynamicDialogRef | undefined;
  entities: any[] = [];
  departments: any[] = [];
  locations: any[] = [];
  lateclosurewise: boolean = true;
  companywise: boolean = true;
  departmentwise: boolean = true;
  locationwise: boolean = true;
  items: MenuItem[] | undefined;
  selectedEntities: any[] = [];
  selectedDepartments: any[] = [];
  selectedLocations: any[] = [];
  date1: null;
  fromDate: any;
  toDate: any;
  constructor(
    private OrganisationstatisticsService: OrganisationstatisticsService, 
    //private dashbordservice:DashboardService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService, 
    public helpservice: PagehelpmodalService,
    public dialogService: DialogService,) { }

  ngOnInit(): void {
    //this.items = this.dashbordservice.getSdlcMenuList();
  }



  downloadgridexcel() {
    this.spinner.show();
    this.OrganisationstatisticsService.orgStatsDataExcel().subscribe((response: Blob) => {
      this.spinner.hide();
      const blob = new Blob([response],
        { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'OrgStats.xlsx'; 
      document.body.appendChild(a); 
      a.click();
      window.URL.revokeObjectURL(url); 
    }, 
    () => {
      this.spinner.hide();
      Swal.fire('Something went wrong', '', 'error');

    }
    )
      ;
  }
}
